import { XhprofRawData } from './XhprofReportGenerator'

export const compareXhprofRawData = (sourceRawData: XhprofRawData, compareWithRawData: XhprofRawData): XhprofRawData => {
    // create a new callgraph with all '0' properties
    const resultRawData: XhprofRawData = setDefaultData(sourceRawData, compareWithRawData)
    const props = ['ct', 'wt', 'pmu']

    Object.keys(resultRawData).forEach(sourceRawDataElement => {
        const sourceValues = sourceRawData[sourceRawDataElement] || resultRawData[sourceRawDataElement]
        const compareValues = compareWithRawData[sourceRawDataElement] || resultRawData[sourceRawDataElement]

        Object.keys(compareValues).forEach(prop => {
            resultRawData[sourceRawDataElement][prop] = compareValues[prop] - sourceValues[prop]

            if (!sourceRawData['main()'] || !compareWithRawData['main()']) {
                return resultRawData
            }

            if (props.indexOf(prop) >= 0 && sourceRawData['main()'][prop] && compareWithRawData['main()'][prop]) {
                resultRawData[sourceRawDataElement]['perc_' + prop] =
                    (compareValues[prop] / compareWithRawData['main()'][prop] - sourceValues[prop] / sourceRawData['main()'][prop]) * 100
            }
        })
    })

    return resultRawData
}
const setDefaultData = (rawData: XhprofRawData, compareData: XhprofRawData): XhprofRawData => {
    const defaultRawData = {}
    const workingSet = { ...rawData, ...compareData }

    Object.keys(workingSet).forEach(functionName => {
        defaultRawData[functionName] = { perc_ct: 0, perc_wt: 0, perc_pmu: 0 }

        Object.keys(workingSet[functionName]).forEach(prop => {
            defaultRawData[functionName] = { ...defaultRawData[functionName], [prop]: 0 }
        })
    })

    return defaultRawData
}
